<app-spinner id="spinner" [loading]="spinnerService.loading$ | async" />
<!-- <p>{{ _slatHistory | json }}</p> -->
<div id="slat-history-screen">
  <app-header-bar
    [title]="_title"
    [dob]="_dob"
    [age]="_age"
    [showClientDetails]="false"
    [showButton]="false"
    (routerLinkClick)="routerLinkClicked()"
    *ngIf="_dob != undefined || _dob != null"
  />
  <!-- Client Information -->
  <div class="dashboard-side-card-container">
    <app-client-information
      id="client-information"
      subtitle=""
      [title]="_clientInformationTitle"
      [urlDisplayText]="_clientInformationDisplayText"
      [url]="_clientInformationUrl"
      [attributes]="_clientInformationAttributes"
      [isVertialOrientation]="true"
    />
  </div>
  <!-- Sub-Menu -->
  <app-sub-menu
    [clientId]="_clientId"
    [totalReviews]="_totalReviews"
    [flipHasAccess]="_hasAccess.flipHasAccess"
    [reddiHasAccess]="_hasAccess.reddiHasAccess"
    [slatHasAccess]="_hasAccess.slatHasAccess"
    [showBackButton]="true"
    (navigateBackClick)="previousRoute()"
  />
  <div id="graph-container">
    <app-primary-card size="full">
      <div id="graph-header">
        <div id="header-title" class="mat-headline-2">
          {{ 'SLAT History' | translate }}
        </div>
        <app-action-toolbar
          [isEdit]="false"
          (editClick)="navigateTo('editSlat')"
          [isFullView]="false"
          (fullViewClick)="navigateTo('fullViewSlat')"
          [isHistory]="false"
          (historyClick)="navigateTo('historySlat')"
          [isReport]="false"
          (reportClick)="navigateTo('reportSlat')"
          [isNew]="true"
          (newClick)="navigateTo('newSlat')"
        />
      </div>
      <div id="slat-graph">
        <app-slat-graph
          [showLegend]="true"
          [clientId]="_clientId"
          [showLimits]="true"
          [visibleFilters]="true"
          [visibleLimits]="true"
          [visibleLegend]="true"
        ></app-slat-graph>
      </div>
    </app-primary-card>
  </div>
  <div id="table-container">
    <app-primary-card size="full" height="635">
      <app-spinner [loading]="spinnerService.loading$ | async"></app-spinner>
      <div id="table-header">
        <div id="header-title" class="mat-headline-2">
          {{ 'SLAT Entries' | translate }}
        </div>
        <app-action-toolbar
          [isEdit]="false"
          (editClick)="navigateTo('editSlat')"
          [isFullView]="false"
          (fullViewClick)="navigateTo('fullViewSlat')"
          [isHistory]="false"
          (historyClick)="navigateTo('historySlat')"
          [isReport]="false"
          (reportClick)="navigateTo('reportSlat')"
          [isNew]="true"
          (newClick)="navigateTo('newSlat')"
        />
      </div>
      <app-table
        id="history-table"
        [dataSource]="_tableData"
        [columnsToDisplay]="_tableColumnsToDisplay"
        [columnDefinitions]="_tableColumnDefinitions"
        pageSize="12"
        kind="styled-header"
        showPager="true"
      />
    </app-primary-card>
  </div>
</div>
